import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Music(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.949 1.934a2.422 2.422 0 011.036 1.984V17.11c-.007.026-.006.053-.006.08a3.822 3.822 0 01-3.816 3.819 3.822 3.822 0 01-3.816-3.818 3.82 3.82 0 013.816-3.816c.659 0 1.28.168 1.821.463v-5.21l-9.452 3.298.002 6.514a3.82 3.82 0 01-3.717 4.684A3.822 3.822 0 012 19.307a3.822 3.822 0 013.817-3.817c.617 0 1.2.147 1.716.408V7.39c0-1.183.745-2.251 1.854-2.661l8.343-3.08a2.422 2.422 0 012.219.285zM5.817 17.49A1.819 1.819 0 004 19.307c0 1.002.815 1.817 1.817 1.817a1.819 1.819 0 001.816-1.817 1.819 1.819 0 00-1.816-1.817zm11.346-2.115a1.817 1.817 0 000 3.634 1.817 1.817 0 000-3.634zm1.26-11.85l-8.344 3.08a.838.838 0 00-.546.785l-.001 2.418 9.452-3.298V3.918a.407.407 0 00-.18-.343.403.403 0 00-.381-.05z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoMusic = React.memo(Music);
export default MemoMusic;